import * as React from 'react';
import { Spinner } from '@fluentui/react';

import styles from './LoadingIndicator.module.scss';

export const LoadingIndicator: React.FC = () => {
    return (
        <div className={styles.container}>
            <Spinner styles={{ circle: { width: 100, height: 100 } }} />
        </div>
    );
};
